<template>
  <header class="flex flex-wrap justify-content-center align-items-center mb-5 bg-white">
    <div class="flex flex-wrap justify-content-between align-items-center lg:w-12">
      <div id="nav-logo" class="mt-2 ml-3">
        <router-link to="/"><img alt="logo cyclinghub" src="../../assets/svg/cyclinghub.svg" width="300px"></router-link>
      </div>
      <div v-if="isMobile" id="mobile-nav">
        <Sidebar v-model:visible="isMenuVisible" header="Menu">
          <div v-for="item in routes" class="flex flex-column justify-content-center align-items-center">
            <div v-if="!item.isLoggedIn || item.isLoggedIn && isLogged" class="mt-4">
              <router-link :to="item.path" class="text-decoration-none">
                <span v-if="item.new" v-badge.danger @click="isMenuVisible = false" class="p-2 text-2xl font-italic font-bold uppercase color-primary border-round-lg hover:surface-200">{{ item.label }}</span>
                <span v-if="!item.new" @click="isMenuVisible = false" class="p-2 font-italic text-2xl font-bold uppercase color-primary border-round-lg hover:surface-200">{{ item.label }}</span>
              </router-link>
            </div>
          </div>
          <div v-if="!isLoggedIn" class="flex flex-column justify-content-center align-items-center mt-5">
            <router-link to="/login" @click="isMenuVisible = false" class="text-decoration-none"><span v-if="!isLoggedIn" class="font-italic uppercase color-primary">Connexion</span></router-link>
            <router-link to="/register">
              <Button label="S'inscrire" @click="isMenuVisible = false" class="bg-primary uppercase font-italic mt-4" rounded></Button>
            </router-link>
          </div>
          <div v-if="isLoggedIn" class="flex flex-column justify-content-center align-items-center mt-5">
            <div class="h-full relative">
              <div class="flex align-items-center nav-border">
                <img :src="checkImgProfilExist(picture!)" class="borderPict minPict lg:mr-0" />
                <span class="mx-3 font-medium">{{ getShortUser(userName!) }}</span>
              </div>
              <div>
                <ul id="main-nav" class="text-xl">
                  <li @click="isMenuVisible = false">
                    <router-link to="/profil"><span class="nav-link"><span class="pi pi-user mr-2"></span>Profil</span></router-link>
                  </li>
                  <li @click="isMenuVisible = false">
                    <router-link to="/services"><span class="nav-link"><span class="pi pi-cog mr-2"></span>Services</span></router-link>
                  </li>
                  <li><a class="nav-link" @click="setLogout(); isMenuVisible = false"><span class="pi pi-sign-out mr-2"></span>Sign Out</a></li>
                </ul>
              </div>
            </div>
          </div>
        </Sidebar>
        <!-- <i id="mobile-nav-icon" class="fa-solid fa-bars" @click="clickMobileNav()"></i> -->
        <i id="mobile-nav-icon" class="fa-solid" :class="isMenuVisible ? 'fa-xmark' : 'fa-bars'" @click="isMenuVisible = true"></i>
      </div>


      <!-- /// Desktop nav -->
      <div v-if="!isMobile" id="nav-items" class="desktop-nav flex-grow-1 flex-wrap justify-content-center align-items-center gap-0 xl:gap-1 hidden lg:flex">
        <div v-for="item in routes">
          <div class="nav-item-content" v-if="!item.isLoggedIn || item.isLoggedIn && isLogged">
            <router-link :to="item.path" class="text-decoration-none">
              <span v-if="item.new" v-badge.danger class="p-2 font-italic font-bold uppercase color-primary border-round-lg hover:surface-200">{{ item.label }}</span>
              <span v-if="!item.new" class="p-2 font-italic font-bold uppercase color-primary border-round-lg hover:surface-200">{{ item.label }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div id="nav-login" v-if="!isLoggedIn" class="desktop-nav ml-4">
        <div class="flex flex-wrap justify-content-center align-items-center gap-4 mr-3">
          <router-link to="/login" class="text-decoration-none"><span v-if="!isLoggedIn" class="font-italic uppercase color-primary">Connexion</span></router-link>
          <router-link to="/register">
            <Button label="S'inscrire" class="bg-primary uppercase font-italic" rounded></Button>
          </router-link>
        </div>
      </div>
      <div v-if="isLoggedIn && !isMobile" class="desktop-nav mr-3 p-2 toggleMenu border-round m-auto" @click="menuProfil = !menuProfil" @mouseover="menuProfil = true" @mouseleave="menuProfil = false">
        <div class="h-full relative">
          <div class="flex align-items-center nav-border">
            <img :src="checkImgProfilExist(picture!)" class="borderPict minPict lg:mr-0" />
            <span class="mx-3 font-medium">{{ getShortUser(userName!) }}</span>
            <i class="pi pi-angle-down"></i>
          </div>
          <div id="subNav" :class="[menuProfil ? 'visible' : 'hidden']" class="zmax absolute w-full surface-overlay shadow-2 border-round pl-3 md:pl-0 mt-2">
            <ul id="main-nav">
              <li>
                <router-link to="/profil"><span class="nav-link"><span class="pi pi-user mr-2"></span>Profil</span></router-link>
              </li>
              <li>
                <router-link to="/services"><span class="nav-link"><span class="pi pi-cog mr-2"></span>Services</span></router-link>
              </li>
              <li><a class="nav-link" @click="setLogout()"><span class="pi pi-sign-out mr-2"></span>Sign Out</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">

import { onMounted, onUnmounted, ref, watch } from 'vue';
import { isLoggedIn, logout } from '@/services/AuthService';
import { checkImgProfilExist, getShortUser } from '@/services/AppService';
import Sidebar from 'primevue/sidebar';

const isLogged = ref(false);
const isMenuVisible = ref(false);
const menuProfil = ref(false);

const isMobile = ref(window.innerWidth < 990);

const updateSize = () => {
  isMobile.value = window.innerWidth < 990;
};

onMounted(() => {
  window.addEventListener('resize', updateSize);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateSize);
});

const userName = ref(localStorage.getItem('user_name'));
const userId = ref(localStorage.getItem('user_id'));
const picture = ref(localStorage.getItem('picture'));

const routes = [
  {
    label: 'Dashboard',
    icon: 'pi pi-fw pi-chart-bar',
    path: '/dashboard',
    isLoggedIn: true,
    new: false
  },
  {
    label: 'Communauté',
    icon: 'pi pi-fw pi-map-marker',
    path: '/community',
    isLoggedIn: true,
    new: false
  },
  {
    label: 'Map',
    icon: 'pi pi-fw pi-map-marker',
    path: '/map',
    isLoggedIn: true,
    new: false
  },
  {
    label: 'Actualités',
    icon: 'fa-regular fa-newspaper',
    path: '/actualities',
    isLoggedIn: false,
    new: true
  },
  {
    label: 'Contact',
    icon: 'fa-regular fa-newspaper',
    path: '/contact',
    isLoggedIn: false,
    new: false
  }
];

onMounted(async () => {
  userName.value = localStorage.getItem('user_name');
  userId.value = localStorage.getItem('user_id');
  picture.value = localStorage.getItem('picture');
});

watch(isLoggedIn, (value) => {
  userName.value = localStorage.getItem('user_name');
  userId.value = localStorage.getItem('user_id');
  isLogged.value = value;
});

const setLogout = async () => {
  logout();
};

</script>

<style scoped>
header {
  box-shadow: 0 0px 9px 0px #c7c7c7;
}

.zmax {
  z-index: 9999;
}

.nav-border {
  border: 1px solid #dcdcdc;
  border-radius: 25px;
  padding: 4px 13px 4px 3px;
}

.toggleMenu {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

#main-nav {
  list-style-type: none;
  padding: 5px 0;
  margin: 0;
  text-align: left;
}

#main-nav li {
  border-left: 2px solid transparent;
  padding: 10px 0;
}

#main-nav li:hover {
  border-left: 2px solid var(--primary);
}

#main-nav li .nav-link {
  padding-left: 30px;
  color: var(--primary);
}

#main-nav li a {
  text-decoration: none;
}

#mobile-nav {
  display: none;
}

.nav-item-content {
  position: relative;
}

.badgeInfo {
  position: absolute;
  bottom: 1.1rem;
  left: 6rem;
}


@media screen and (max-width: 990px) {

  .desktop-nav {
    display: none !important;
  }

  #nav-logo {
    display: inline-block;
    text-align: center;
    margin: 0 auto;
  }

  #mobile-nav {
    display: inline-block;
    margin-left: 1.7rem;
  }

  #mobile-nav i {
    font-size: 2rem;
    cursor: pointer;
  }

  #nav-login {
    display: block;
    text-align: center;
    margin: 0 auto !important;
  }

  #main-nav {
    list-style-type: none;
    margin: 0;
    text-align: left;
  }

  #main-nav li {
    padding: 10px 0;
  }

  #main-nav li .nav-link {
    padding-left: 20px;
    color: var(--primary);
  }

  #main-nav li a {
    text-decoration: none;
  }

  #nav-items div {
    padding-bottom: 10px;
  }

}
</style>